import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/nQ6Cme7gERYRZaFjNmDggU/ChatGPT_Image_15_sept_2026,_11_25_05.png';
export function HeroOferta() {
  return <header className="relative overflow-hidden border-b border-violet-line/60 bg-violet-deep" data-id="element-23" data-mp="27hzr75jrzho7">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gold/50" data-id="element-24" data-mp="2ch2lbuy7w3he" />

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.4,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-25" data-mp="1jq2frfk8mrnm">
        <img src={HERO_IMAGE} alt="Freddy Pimentel presentando la mentoría grupal Recupérate con Poder: 5 semanas con PNL, acompañamiento en vivo y una comunidad que te sostiene." className="w-full" width={1656} height={932} data-id="element-26" data-mp="1onua0g8cupuz" />
      </motion.div>

      <div className="mx-auto max-w-5xl px-6 pb-20 pt-10 sm:pb-24 sm:pt-12 lg:px-8" data-id="element-27" data-mp="344cjbwjekvmk">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-28" data-mp="231az0slq7hls">
          <h1 className="font-serif text-4xl font-medium leading-[1.05] text-bone sm:text-5xl md:sr-only" data-id="element-29" data-mp="1p21wgvqg0m0a">
            <span className="mb-4 block font-sans text-xs font-medium uppercase tracking-[0.28em] text-gold" data-id="element-30" data-mp="1k2oxxdq7lqhv">
              Mentoría grupal · 5 semanas
            </span>
            Recupérate con Poder
          </h1>

          <p className="mt-6 max-w-reading font-sans text-lg font-light leading-relaxed text-bone/80 sm:text-xl md:mt-0" data-id="element-31" data-mp="1acdtzr6izhaz">
            El programa que te lleva, semana a semana, desde el nivel de
            consciencia donde estás atrapado ahora, hasta el{' '}
            <span className="text-gold-soft" data-id="element-32" data-mp="11ea64o82i8g0">Amor y la Paz real</span> — con
            PNL, acompañamiento en vivo, y una comunidad que te sostiene en el
            camino.
          </p>

          <div className="mt-10" data-id="element-33" data-mp="mrv38std90oa">
            <a href="#inscripcion" className="group inline-flex items-center gap-3 rounded-full border border-gold/70 px-8 py-4 font-sans text-sm font-medium tracking-wide text-gold transition-colors duration-200 ease-out hover:bg-gold hover:text-violet-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-violet-deep" data-id="element-34" data-mp="qrvey5p2yxrn">
              Ver cómo funciona
              <ArrowDownIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-y-0.5" aria-hidden="true" data-id="element-35" data-mp="1ahfjh3y4xjtv" />
            </a>
          </div>
        </motion.div>
      </div>
    </header>;
}